import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['subMenu']

  connect() {
    this.subMenuTarget.classList.add('header__sub-menu__pc_overflow_hidden')
    const subDropdownMenuList = this.subMenuTarget.querySelectorAll(
      '.menu-dropdown-with-hover__header-sub-dropdown'
    )
    subDropdownMenuList.forEach((menu) => {
      menu.setAttribute(
        'data-action',
        'mouseover->sub-menu#overSubMenu mouseout->sub-menu#leaverSubMenu'
      )
    })
  }

  overSubMenu() {
    if (
      !this.subMenuTarget.classList.contains(
        'header__sub-menu__pc_overflow_hidden'
      )
    ) {
      return
    }
    this.subMenuTarget.classList.remove('header__sub-menu__pc_overflow_hidden')
  }

  leaverSubMenu() {
    this.subMenuTarget.classList.add('header__sub-menu__pc_overflow_hidden')
  }
}
